import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-[#0a0d12] text-white border-t border-white/5 overflow-hidden">
      <div className="absolute inset-0 tech-grid tech-grid-mask opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-white text-black font-bold">V</span>
              <span className="text-2xl font-semibold tracking-tight font-display">VEX</span>
            </div>
            <p className="text-white/60 max-w-md text-sm leading-relaxed">
              Vex is an angel collective backing the next generation of frontier
              technology — AI, robotics, biotech, climate, and beyond.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {['twitter-x', 'linkedin', 'github', 'medium'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-lg border border-white/10 text-white/70 hover:text-white hover:border-white/30 transition-colors"
                  aria-label={icon}
                >
                  <i className={`ri-${icon}-line text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs font-mono uppercase text-white/40 mb-4 tracking-widest">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/story" className="text-white/80 hover:text-white transition-colors">Our Story</Link></li>
              <li><Link to="/investing" className="text-white/80 hover:text-white transition-colors">Investing</Link></li>
              <li><Link to="/building" className="text-white/80 hover:text-white transition-colors">Building</Link></li>
              <li><Link to="/advisory" className="text-white/80 hover:text-white transition-colors">Advisory</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-mono uppercase text-white/40 mb-4 tracking-widest">Connect</div>
            <ul className="space-y-3 text-sm">
              <li><a href="mailto:hello@vex.vc" className="text-white/80 hover:text-white transition-colors">hello@vex.vc</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors">Press kit</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors">Careers</a></li>
              <li><a href="#" className="text-white/80 hover:text-white transition-colors">Office hours</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-white/40 font-mono">
          <div>© {new Date().getFullYear()} VEX Capital. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Disclosures</a>
          </div>
        </div>
      </div>
    </footer>
  );
}